<template>
	<div>
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("components") }}</h1>
			</div>
			<div class="col-7 mb-4">
				<router-link to="/curriculum-mapping/components/add" class="float-right btn btn-primary"
					><b-icon icon="plus"></b-icon> {{ $t("new") }}</router-link
				>
			</div>
		</div>
        <div class="list-group no-border border-radius-2 mt-2" v-if="components && loaded">
            <div class="list-group-item d-none d-sm-inline">
                <div class="row">
                    <div class="col-12 col-sm-6 font-bold">{{ $t("name") }}</div>
                </div>
            </div>
            <ScrollPaginator
                :data="components"
                :submitting="submitting"
                :filters="filters"
                @toPage="toPage"
            >
                <template v-slot:item="{item: component}">
                    <div class="list-group-item">
                        <router-link class="link-bare" :to="`/curriculum-mapping/components/${component.id}`">
                            <div class="row"
                                @contextmenu.prevent="handleRightClick(component.id)"
                            >
                                <div class="col-xs-12 col-sm-12">
                                    <span class="font-bold d-inline d-sm-none">{{ $t("name") }}</span>
                                    {{ component.title }}
                                    <button class="btn btn-danger float-right" v-if="showDeleteButton[component.id]" @click="deleteComponent(component.id)">{{ $t('delete') }}</button>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </template>
            </ScrollPaginator>
        </div>
        <table v-else class="table">
            <tr v-for="item in Array(5)" v-bind:key="item">
                <td>
                    <div class="skeleton midnight h16 w-half"></div>
                </td>
            </tr>
		</table>
        <div class="card mt-2" v-if="adding">
            <h5 class="card-header">{{ $t('new-component') }}</h5>
            <div class="card-body">
                <TextInput :label="$t('title')" v-model="newComponent.title"></TextInput>
                <button class="float-right btn btn-primary" @click="saveComponent()">{{ $t('add') }}</button>
            </div>
        </div>

	</div>
</template>

<script>
import ScrollPaginator from "../../../components/Table/ScrollPaginator.vue";

export default {
    components:{
        ScrollPaginator
    },
	data: function () {
		return {
            components: [],
            showDeleteButton: {},
            loaded: false,
            adding: false,
            newComponent:{},
            submitting: false,
            filters: {
                page: 1,
                page_size: 10,
                total:0,
                search: '',
                sort: ''
            },
            details:{},
            nodes:{}
		};
	},
	mounted() {
        this.getComponents();
	},
	methods: {
        handleRightClick(component_id) {
            for (const id in this.showDeleteButton) {
                if (id !== component_id) {
                    this.$set(this.showDeleteButton, id, false);
                }
            }
            this.$set(this.showDeleteButton, component_id, true);
        },
		deleteComponent(id){
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("delete-topic-question"),
                content: this.$t("delete-topic-dialog"),
				confirmCallBack: function () {
                    this.$store.commit("showBlockingSpinner");
					this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/delete`, {
						data: {
							id: id
						},
						method: 'post'
					}).then((res) => {
						if (res.status === "SUCCESS") {
                            this.$store.commit("hideBlockingSpinner");
                            this.loaded = false;
                            this.getComponents();
						}
						else {
							console.log(`Not deleted`)
						}
					});
				}.bind(this),
			});
		},

        saveComponent() {
            this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/save`, {
				method: "post",
				data: this.newComponent
			})
			.then((res) => {
				if (res.status === "SUCCESS") {
                    this.components.push(res.result);
                    this.newComponent={};
                    this.adding = false;
                    this.$store.commit("hideBlockingSpinner");
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = "There was a problem saving the component.";
					}
				}
			}).catch((error) => {
            	this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.error = "There was a problem saving the component.";
			});
        },
        toPage(pageNo) {
            this.filters.page = pageNo;
            this.getComponents()
        },
        getComponents() {
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/list`, {
                method: 'post'
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.components = res.results;
                    this.loaded = true;
                }
                else {
                    console.log(`Not loaded`);
                }
            });
		},
	}
};
</script>
